import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoEllipsisDirective } from './avano-ellipsis.directive';
import { AvanoLoadingIndicatorDirective } from './avano-loading-indicator/avano-loading-indicator.directive';
import { AvanoTemplate } from './avano-template.directive';
import { ClearInputDirective } from './clean-input/clean-input.directive';
import { NumberInputDirective } from './avano-number-input/number-input.directive';
import { TypedTemplateDirective } from './typed-template.directive';
import { InputTextDirective } from './avano-input-text/input-text.directive';
import { InputTextareaDirective } from './avano-input-textarea/input-textarea.directive';

@NgModule({
  imports: [CommonModule],
  exports: [
    AvanoEllipsisDirective,
    NumberInputDirective,
    AvanoLoadingIndicatorDirective,
    AvanoTemplate,
    TypedTemplateDirective,
    ClearInputDirective,
    InputTextDirective,
    InputTextareaDirective
  ],
  declarations: [
    AvanoEllipsisDirective,
    NumberInputDirective,
    AvanoLoadingIndicatorDirective,
    AvanoTemplate,
    TypedTemplateDirective,
    ClearInputDirective,
    InputTextDirective,
    InputTextareaDirective
  ]
})
export class AvanoDirectivesModule {}
